import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IUsersContext, UsersContext } from '../../../../usersState/usersContext';
import Item from './components/Item';
import classNames from 'classnames';
import style from './List.module.scss';

const List: React.FC = () => {
	const { users } = useContext<IUsersContext>(UsersContext);

	const nameHeadingClasses = classNames(style.name, style.heading);
	const emailHeadingClasses = classNames(style.email, style.heading);
	const roleHeadingClasses = classNames(style.role, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="listing"
					translationKey="nameLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={emailHeadingClasses}
					translationNameSpace="listing"
					translationKey="emailLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={roleHeadingClasses}
					translationNameSpace="listing"
					translationKey="roleLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{users.users.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};

export default List;
